import React, { useEffect, useState } from "react";
import { Button, Grid, TextField, Typography } from "@mui/material";
import { useFetch } from "../../../services/hooks/useFetch";
import { deviceApiPrefix } from "../../../utils/main";
import { useFusionAuth, type UserInfo } from "@fusionauth/react-sdk";

export default function CompanySettingsPage() {
  const [fetchRequired, setFetchRequired] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [companyName, setCompanyName] = useState("");

  const { data: company, fetch: fetchCompanies } = useFetch<Company, void>();

  const { update: updateCompany } = useFetch<void, Partial<Company>>();

  const [displayErrors, setDisplayErrors] = useState(false);

  const { userInfo } = useFusionAuth<UserInfo>();

  const companyId = userInfo?.companyId;

  useEffect(() => {
    void fetchCompanies(`${deviceApiPrefix}/companies/${companyId}`);

    if (fetchRequired) setFetchRequired(false);
  }, [fetchCompanies, companyId, fetchRequired]);

  useEffect(() => {
    if (company) setCompanyName(company.name);

    if (fetchRequired) setFetchRequired(false);
  }, [company, fetchRequired]);

  const updateCompanyName = function (companyId: string, name: string) {
    void updateCompany({
      path: `${deviceApiPrefix}/companies/update/${companyId}`,
      body: { name: name },
      postResponseAction: () => setFetchRequired(true),
    });
  };

  return (
    <Grid container direction={"column"} className="company-settings-item">
      <div className="company-settings-item">
        <Grid>
          <Typography variant="h4">Company Settings</Typography>
        </Grid>
        <br />
        <Grid>
          <Typography variant="body2">
            Information about the companies.
          </Typography>
        </Grid>
        <br />
        <Grid>
          <Typography variant="body2">* Required fields</Typography>
        </Grid>
        <br />
        <Grid>
          {editMode ? (
            <TextField
              required
              variant="outlined"
              label="Company Name"
              className="settings-text-input"
              sx={{ width: "50ch" }}
              value={companyName}
              slotProps={{
                input: {
                  readOnly: !editMode,
                },
              }}
              onChange={(event) => {
                setCompanyName(event.target.value);
              }}
              error={displayErrors && companyName === ""}
              helperText={
                displayErrors && companyName === ""
                  ? "This field is required"
                  : ""
              }
            />
          ) : (
            <>
              <Typography variant="caption">Company Name *</Typography>
              <Typography variant="body1" sx={{ width: "50ch" }}>
                {companyName}
              </Typography>
            </>
          )}
        </Grid>
        <br />
        <Grid container justifyContent={"right"}>
          {(editMode && (
            <>
              <Button
                variant="outlined"
                onClick={() => {
                  setEditMode(false);
                  setDisplayErrors(false);
                  setCompanyName(company ? company.name : "");
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="update-button"
                sx={{ marginLeft: "5px" }}
                onClick={() => {
                  if (companyName !== "") {
                    if (company && companyName !== company.name) {
                      updateCompanyName(company.id, companyName);
                    }

                    setDisplayErrors(false);
                    setEditMode(false);
                  } else {
                    setDisplayErrors(true);
                  }
                }}
              >
                Update
              </Button>
            </>
          )) || (
            <Button variant="contained" onClick={() => setEditMode(true)}>
              Edit
            </Button>
          )}
        </Grid>
      </div>
    </Grid>
  );
}
